import { render } from "./WareInBatchReceive.vue?vue&type=template&id=2f7b6260&scoped=true"
import script from "./WareInBatchReceive.vue?vue&type=script&lang=js"
export * from "./WareInBatchReceive.vue?vue&type=script&lang=js"

import "./WareInBatchReceive.vue?vue&type=style&index=0&id=2f7b6260&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7b6260"]])

export default __exports__